import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import { withIntl, IntlProps } from 'ha/i18n';
import units from 'ha/theme/units';

interface Props {
  className?: string;
  hasAlert: boolean;
  onConfirm: (a: { successText: string; errorText: string }) => void;
  onClick: () => void;
}

const styles = createStyles({
  button: {
    padding: units.rem(1),
    borderRadius: 0,
  },
});

export class SearchAlertConfirmationButton extends React.PureComponent<
  Props & WithStyles<typeof styles> & IntlProps
> {
  handleClick = () => {
    const {
      hasAlert,
      onConfirm,
      onClick,
      intl: { T },
    } = this.props;

    onConfirm({
      successText: hasAlert
        ? T('search_alert_updated_message')
        : T('search_alert_created_message'),
      errorText: hasAlert
        ? T('search_alert_update_error_message')
        : T('search_alert_create_error_message'),
    });
    onClick();
  };

  render() {
    const {
      className,
      intl: { T },
    } = this.props;

    return (
      <Button
        variant="contained"
        color="secondary"
        onClick={this.handleClick}
        className={className}
      >
        {T('search_alert_confirmation_button')}
      </Button>
    );
  }
}

export default withStyles(styles)(withIntl(SearchAlertConfirmationButton));
